module.exports = __webpack_public_path__ + "img/close-icon-2.16879754.svg";